import type { ReactElement } from 'react';
import { RESULT_DESIGN_PLACEHOLDER } from '@/constants/resultDesignPlaceholder';

type Align = 'left' | 'center' | 'right';

/** 스켈레톤 전용: '예정' + 열(역할) 꼬리 — 컬럼/행 구조가 한눈에 보이게 함 */
export function DesignDataCell({ hint, align = 'left' }: { hint: string; align?: Align }): ReactElement {
  const a =
    align === 'center'
      ? 'items-center text-center'
      : align === 'right'
        ? 'items-end text-right'
        : 'items-start text-left';
  return (
    <div className={`flex flex-col ${a} min-h-10 justify-center`}>
      <span className="text-sm text-slate-800 font-medium normal-case leading-snug">{RESULT_DESIGN_PLACEHOLDER}</span>
      <span className="text-[10px] text-slate-400 font-normal normal-case leading-tight mt-0.5 max-w-full break-words">
        {hint}
      </span>
    </div>
  );
}
